import Button from "@mui/material/Button";
import * as theme from '../../theme';

const AvailableScanDates = ({
  availableDates,
  selectedDateIndex,
  hoveredDateIndex,
  setHoveredDateIndex,
  handleDateSelect,
  showMoreButtonVisible,
  fetchMoreDates,
}) => {
  const styles = {
    dateRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 10px',
      marginBottom: 8,
      backgroundColor: theme.Colors.GrayLight,
      borderRadius: 8,
      fontSize: 14,
      cursor: 'pointer',
    },
    dateRowHover: {
      backgroundColor: theme.Colors.GoldDark,
    },
    dateRowSelected: {
      backgroundColor: theme.Colors.GoldLight,
    },
    showMoreContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 10,
      marginBottom: 10,
    },
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      {availableDates.length > 0 ? (
        availableDates.map((item, index) => (
          <div
            key={index}
            style={{
              ...styles.dateRow,
              ...(hoveredDateIndex === index ? styles.dateRowHover : {}),
              ...(selectedDateIndex === index ? styles.dateRowSelected : {}),
            }}
            onClick={() => handleDateSelect(index)}
            onMouseEnter={() => setHoveredDateIndex(index)}
            onMouseLeave={() => setHoveredDateIndex(null)}
          >
            <span>{item.date.format('dddd, MMMM D, YYYY')}</span>
            <span>{item.availableSlots} Slots</span>
          </div>
        ))
      ) : (
        <div style={{ fontSize: '14px', color: '#6b7280', textAlign: 'center' }}>
          No available scan slots found for the next 3 months.
        </div>
      )}
      {showMoreButtonVisible && (
        <div style={styles.showMoreContainer}>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            onClick={fetchMoreDates}
          >
            Show More
          </Button>
        </div>
      )}
    </div>
  );
};

export default AvailableScanDates;